import React, { useState } from "react";
import { CardHeader, CardBody } from 'reactstrap';
import PropTypes from "prop-types";

import "./box.scss";

const Box = props => {
    const { tab, tabTitle, marginBottom, children, marginTop, zIndex, className = '', showCollapse = false, initialCollapse = false } = props;
    const [collapse, setCollapse] = useState(initialCollapse);

    const buttonCollape = () => {
        return (
            <i onClick={() => setCollapse(!collapse)} className={"collapse-icon " + (collapse ? "fa fa-plus-square" : "fa fa-minus-square")}></i>
        )
    }

    return (
        <div className="box-collapsable">
            <div className={`card ${className}`}
                style={{
                    marginTop,
                    marginBottom,
                    position: "relative",
                    zIndex: (zIndex ? zIndex : (tab ? 9 : 99))
                }}>
                <CardHeader>
                    <i className="icon-note"></i><strong>{tabTitle}</strong>{showCollapse ? buttonCollape() : ""}
                </CardHeader>
                <CardBody className={"collapsable " + (collapse ? "active" : "")}>
                    {children}
                </CardBody>
            </div>
        </div>

    );
};

Box.defaultProps = {
    tab: false
};

Box.propTypes = {
    tab: PropTypes.bool,
    tabTitle: PropTypes.string,
    marginBottom: PropTypes.number,
    children: PropTypes.node.isRequired
};

export { Box }
